export var CouponType;
(function (CouponType) {
    CouponType[CouponType["Percentage"] = 0] = "Percentage";
    CouponType[CouponType["FixAmount"] = 1] = "FixAmount";
})(CouponType || (CouponType = {}));
export class Coupon {
}
